import { createI18n } from 'vue-i18n';
import en from '@/locales/en.json';
import nl from '@/locales/nl.json';
import de from '@/locales/de.json';

export type Locale = 'en' | 'nl' | 'de';

export const supportedLocales: Locale[] = ['en', 'nl', 'de'];

// Restore locale from localStorage, fallback to browser language or 'en'
function getInitialLocale(): Locale {
    if (typeof window === 'undefined') return 'en';

    const stored = localStorage.getItem('nv:locale') as Locale | null;
    if (stored && supportedLocales.includes(stored)) return stored;

    const browserLang = navigator.language.split('-')[0] as Locale;
    if (supportedLocales.includes(browserLang)) return browserLang;

    return 'en';
}

const i18n = createI18n({
    legacy: false,
    locale: getInitialLocale(),
    fallbackLocale: 'en',
    messages: { en, nl, de },
});

export function setLocale(locale: Locale): void {
    i18n.global.locale.value = locale;
    localStorage.setItem('nv:locale', locale);
    document.documentElement.setAttribute('lang', locale);
}

export default i18n;
